import React from 'react'
import ForgotPasswordForm from './ForgotPasswordForm'
import Logo from 'components/template/Logo'

const ForgotPassword = () => {
    return <><div className="mb-8 text-center md:hidden"><Logo mode="dark" imgClass="mx-auto text-center w-[160px]"  /></div><ForgotPasswordForm disableSubmit={false} /></>
}

export default ForgotPassword
